import { Text } from "@chakra-ui/react"
export const ComingSoonPage = () => {
    return <Text>Coming soon!</Text>
}